module.exports = __webpack_public_path__ + "static/img/life_privileges-img-qm.2ae40aad.png";